import { render, staticRenderFns } from "./remarkImage.vue?vue&type=template&id=4ef153f2&scoped=true"
import script from "./remarkImage.vue?vue&type=script&lang=js"
export * from "./remarkImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef153f2",
  null
  
)

export default component.exports